import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 32 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.85, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ number, label, dark = false }) => (
  <Reveal>
    <p className={`font-mono text-xs tracking-[0.25em] uppercase ${dark ? "text-[#D4A359]" : "text-[#C85A32]"}`} data-testid={`chapter-${number}`}>
      Capitolo {number} — {label}
    </p>
  </Reveal>
);
